var _path, _path2, _circle, _circle2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevsecops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 28 L188 42 V80 C188 104 170 118 150 126 C130 118 112 104 112 80 V42 Z",
    fill: "#fff",
    stroke: "#F97316",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135 76 l10 10 21 -23",
    stroke: "#F59E0B",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 58,
    r: 6,
    fill: "#FDBA74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 100,
    r: 6,
    fill: "#F97316"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 80,
    r: 6,
    fill: "#F59E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58 H104 M72 100 H104 M196 80 H228",
    stroke: "#FDBA74",
    strokeWidth: 1.6,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevsecops);
export default __webpack_public_path__ + "static/media/devsecops.d28ae20df4c2f7fe2b0ea9eb78efaefc.svg";
export { ForwardRef as ReactComponent };